import React, {useEffect, useState} from "react";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import AccountInformationView from "../../views/ver_24.10/AccountInformation.view";
import {getCompanyInfoService} from "../../services/company.service";
import {updateCompanyInfoService} from "../../services/rating.service";
import {useAuth} from "../../context/auth";
import {useHistory} from "react-router-dom";
import {REGIONS_MAP} from "../../utils/META/cat_101";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";

const AccountInformation = () => {
    const [showLoader, setShowLoader] = useState(false);
    const { authUser } = useAuth();
    const history = useHistory();

    const [companyInfo, setCompanyInfo] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const getCompanyInfo = async () => {
        try {
            setShowLoader(true);
            const result = await getCompanyInfoService();
            console.log("Company Info Service API: ", result.data.comp);
            if (!result.error && result.data) {
                if (result.data.comp) {
                    setCompanyInfo({
                        NameOrg: result.data.comp.name_org,
                        Region: result.data.comp.region,
                        // sameAsOrgInfo: true,
                        nameCompany: result.data.comp.billing_info && result.data.comp.billing_info.name_org ? result.data.comp.billing_info.name_org : '',
                        addressCompany: result.data.comp.billing_info && result.data.comp.billing_info.address_org ? result.data.comp.billing_info.address_org : '',
                        contactCompany: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_org ? result.data.comp.billing_info.contact_no_org : '',
                        nameContactPerson: result.data.comp.billing_info && result.data.comp.billing_info && result.data.comp.billing_info.name_contact ? result.data.comp.billing_info.name_contact : '',
                        emailContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.email_contact ? result.data.comp.billing_info.email_contact : '',
                        contactContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_contact ? result.data.comp.billing_info.contact_no_contact : '',
                    });
                }
            }
        } catch (e) {
            // already toasted the error
            setShowLoader(false);
        } finally {
            setShowLoader(false);
        }
    }

    useEffect(() => {
        getCompanyInfo().then((res) => `fetch initiated, ${res}`);
    }, [refresh]);

    useEffect(() => {
        console.log("Updated companyInfo:", companyInfo);
    }, [companyInfo]);

    const data = {
        defaultInitialValues: companyInfo,
    };

    const actions = {
        companyInfoUpdateAction : async (values) => {
            setShowLoader(true);
            try {
                const response = await updateCompanyInfoService(values);
                if (response && !response.error) {
                    console.log("Company Info Updated");
                    setRefresh(prev => !prev);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setShowLoader(false);
            }
        },
        signUpAction: () => {
            localStorage.setItem(LOCAL_STORAGE_KEYS.redirect_to_url, `/account/information`)
            history.push(`/auth/persist_guest_account`);
        }
    };

    const options = {
        isGuestUser: authUser.is_guest,
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <AccountInformationView data={data} actions={actions} options={options}/>
            </div>
        </>
    );

}

export default AccountInformation;